<script setup lang="ts">
import { onMounted, toRefs,watch,reactive, ref } from "vue";

const props = defineProps({
    label: {
      type:String,
      required:true
    },
    id: {
      type:String,
      required:true
    },
    name: {
      type:String,
      required:true
    },
    placeHolder: {
      type:String,
      default: () => {
        return '';
      }
    },
})

const isSecret = ref(true);
const changeSecret = () => {
  isSecret.value = !isSecret.value;
}
</script>
<style scoped>

</style>

<template>
  <div>
    <label :for="id" class="text-sm font-medium text-gray-900 block mb-2">{{ label }}</label>
    <div class="flex items-center relative">
      <input :type="isSecret ? 'password' : 'text'" :name="name" :id="id" :placeholder="placeHolder" class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-2.5">
      <span v-if="isSecret" class="cursor-pointer absolute right-3" @click="changeSecret"><i class="fa-regular fa-eye"></i></span>
      <span v-else class="cursor-pointer absolute right-3" @click="changeSecret"><i class="fa-regular fa-eye-slash"></i></span>
    </div>
  </div>
</template>

